import { Injectable } from '@angular/core';
import { ApiNameList } from '../../../../environments/api-name-list';
import { HttpClientService } from '../../services/http-client-service';
import { AppConfigService } from '../../../main/app-config.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class SaeLoginService {
  public baseUrl = '';
  private environment: any;
  constructor(public httpClientService: HttpClientService, private appConfigService: AppConfigService) {
    this.baseUrl = ApiNameList.restApi.baseUrl;
    this.environment = this.appConfigService.getConfig();
  }

  authenticate(emailAddress: string, password: string) {
    const requestObject = {
      emailAddress,
      password
    };
    return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.login, requestObject);
  }
  getUserId(email: string) {
      const requestObject = {
          email
      };
      if (this.environment.environment === 'local') {
          let headers = new HttpHeaders();
          headers = headers.set('Content-Type', 'application/json');
          headers = headers.set('sae-portal', 'student');
          return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getUserId, requestObject, headers);
      } else {
          return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getUserId, requestObject);
      }
  }

  authorizeOkta(loginHint?: string) {
      const requestObject = loginHint ? { emailAddress: loginHint } : {};
      if (this.environment.environment === 'local') {
          let headers = new HttpHeaders();
          headers = headers.set('Content-Type', 'application/json');
          headers = headers.set('sae-portal', 'student');
          return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.authorizeOkta, requestObject, headers);
      } else {
          return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.authorizeOkta, requestObject);
      }
  }
}
